
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Create, getFoodTypes
} from "adminApi/FoodApi/Food.js";
import { validateForm } from "utils/validation";
import { fooditemRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddFoodForm from "./Componates/AddFoodForm";
import fields from "../json/FoodListFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";

const AddFood = () => {

  const navigate = useNavigate();
  const { formdata } = fields;

  // Initialize form values from JSON fields
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, handleFileChange, setErrors } = useFormChange(
    initialValues,
    fooditemRules
  );

  const { data: FoodTypesOptions = [] } = useFetchAllData(getFoodTypes);

  // Form submit
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await Create({ data: formData });
    },
    (vals) => {
      const err = validateForm(vals, fooditemRules)
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Food Created Successfully"
  );

  return (
    <>
      {(loadingSubmit) && <Spinner isSpinner={true} />}
      <AddFoodForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        FoodTypesOptions={FoodTypesOptions}
        title="Create Food Item"
        handleFileChange={handleFileChange}
        imagePreview={values.imagePreview || values.image}
      />
    </>
  );
};

export default AddFood;
